<template>
  <div class="right_menu">
    <!-- <img v-if="currentUser.is_login != '0'" :src="'/img/rank/' + currentUser.rank + '.png'" class="rank_icon" @click="page('/my-page')"> -->
    <div class="point_area">
      <div class="login coin">
        <!-- <span v-if="currentUser.is_login == '0'" class="pc point_block append_coin" @click="page('/login')">
          0C
        </span>
        <span v-if="currentUser.is_login != '0'" class="pc point_block append_coin"  @click="page('/exchange-card')">
          {{currentUser.coin | commaDecimal}}C
        </span> -->
      </div>
      <div class="bell" v-if="currentUser.is_login != '0' && !isStoreRelatedPage" @click="page('/notice-list')">
        <img src="/img/menu/news2.png" class="bell-icon"  />
        <span v-if="currentUser.is_notice" class="notification-badge"></span>
      </div>
      <div class="login">
        <span v-if="currentUser.is_login == '0'" class="pc point_block not_login" @click="showLoginModal">
          {{ t('会員登録 / ログイン') }}
        </span>
        <span v-if="currentUser.is_login != '0'" class="pc point_block append_gem" @click="page('/buy-point')">
          {{currentUser.point | comma}}
        </span>
        <!-- Xmarket機能廃止
        <span v-if="currentUser.is_login != '0'" class="pc point_block append_sale_amount" @click="page('/request-payment')">
          {{currentUser.market_sales_amount | comma}}
        </span> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
  separateDecimalNumber,
} from '@/common/util/format';
import t from '@/plugins/i18n';

export default {
  mixins: [t],
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
    commaDecimal(value) {
      return separateDecimalNumber(value);
    },
  },

  methods: {
    page(url) {
      this.$emit('changePage', url);
    },
    showLoginModal() {
      this.$router.push('/login');
    },
  },

  computed: {
    isStoreRelatedPage() {
      const path = this.$route && this.$route.path;
      return !!path && /^\/store(\/|-|$)/.test(path);
    },
    hasNotification() {
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.right_menu {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 40px;
  margin-top: 15px;
  .logo {
    width: 200px;
    margin-right: 10px;
  }
  .tokkyo {
    width: 60px;
    margin-right: 10px;
    @media screen and  (max-width: $tabletWidth) {
      width: 32px;
      margin-right: 5px;
    }
  }
  .rank_icon {
    width: 50px;
    margin-right: 10px;
    @media screen and  (max-width: $tabletWidth) {
      width: 32px;
      margin-right: 5px;
    }
  }
  .point_area {
    display: flex;
    align-items: center;
    .login {
      display: flex;
      gap: 4px;
      span {
        display: block;
        background-color: $white;
        border-radius: 4px;
        width: 142px;
        height: 30px;
        padding-right: 30px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 5px 0;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4);
      }
      .not_login {
        font-size: 12px;
        padding: 0;
        display: flex;
        justify-content: center;
        cursor: pointer;
        color: $gray2;
        font-weight: bold;
      }
    }
    .bell {
      position: relative;
      width: 40px;
      height: 40px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 5px;
      .bell-icon {
        width: 25px;
      }
      .notification-badge {
        position: absolute;
        top: 7px;
        right: 7px;
        width: 11px;
        height: 11px;
        background-color: #b81b25;
        border-radius: 50%;
      }
    }
  }
  .append_coin {
    background-image: url('/img/coin.png');
    background-repeat: no-repeat; /* 画像を繰り返さない */
    background-position: 5px center; /* 画像を左に配置し、上下を中央揃え */
    background-size: auto 60%; /* 画像のサイズは自動調整 */
  }
  .append_gem {
    background-image: url('/img/star_coin.webp');
    background-repeat: no-repeat; /* 画像を繰り返さない */
    background-position: 7px center; /* 画像を左に配置し、上下を中央揃え */
    background-size: auto 60%; /* 画像のサイズは自動調整 */
  }
  .append_sale_amount {
    background-image: url('https://img.icons8.com/?size=100&id=ij9Fvjj8ABOS&format=png&color=000000');
    background-repeat: no-repeat; /* 画像を繰り返さない */
    background-position: 7px center; /* 画像を左に配置し、上下を中央揃え */
    background-size: auto 60%; /* 画像のサイズは自動調整 */
  }
}
@media screen and  (max-width: $tabletWidth) {
  .right_menu {
    margin-right: 10px;
    .logo {
      width: 120px;
    }
    .point_area {
      .login {
        span {
          display: block;
          background-color: $white;
          border-radius: 3px;
          max-width: 900px;
          min-width: 90px;
          width: auto;
          height: 24px;
          padding-right: 10px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin: 5px 0;
          font-size: 12px;
          white-space: nowrap;
          &.not_login{
            min-width: 125px;
          }
        }
      }
    }
  }
}
</style>
